const Expander = {
	init() {
		var panels = document.querySelectorAll('.office-module-item ');
		panels.forEach((panel) => {
			var button = panel.querySelector('.expand-building');
			button.addEventListener('click', () => {
				panel.classList.toggle('expanded');
			});
		});
		var faqs = document.querySelectorAll('.faq');
		faqs.forEach((faq) => {
			faq.addEventListener('click', (e) => {
				faq.classList.toggle('active');
			});
		});
	},
};

export default Expander;
